// @ts-nocheck
import React, { useEffect, useState } from 'react'
import { imageCache } from '../../utils/imageCache'
import { ReactComponent as GroupIcon } from '../../assets/icons/group-icon.svg'
import { ReactComponent as PinIcon } from '../../assets/icons/pin-02.svg'
// This component renders the header of the Asset Page, which includes the asset's image, name, description, key statistics, and controls for pinning the asset to the dashboard.
const AssetPageHeader = ({ selectedAsset, ownerOrOrgLabel }) => {
  const [assetImageUrl, setAssetImageUrl] = useState<string | null>(null)
  useEffect(() => {
    const loadAssetImage = async () => {
      if (!selectedAsset?.imageUrl) {
        setAssetImageUrl(null)
        return
      }
      try {
        const signedUrl = await imageCache.getSignedUrl(selectedAsset.imageUrl)
        setAssetImageUrl(signedUrl || null)
      } catch (error) {
        console.error('Error fetching asset image URL:', error)
        setAssetImageUrl(null)
      }
    }

    loadAssetImage()
  }, [selectedAsset?.imageUrl])

  const formatCoordinate = (value: number | string | null | undefined, digits: number) => {
    if (value === null || value === undefined) return '--'
    const numeric = typeof value === 'number' ? value : Number(value)
    if (Number.isFinite(numeric)) return numeric.toFixed(digits)
    return String(value)
  }
  const assetName = selectedAsset?.name || 'Asset'
  const assetDescription = selectedAsset?.description || 'No desc'
  const assetImage = assetImageUrl || selectedAsset?.imageUrl || null
  const assetValue = selectedAsset?.value != null ? `${selectedAsset.value} MW` : 'N/A'
  const latitude = formatCoordinate(selectedAsset?.lat, 4)
  const longitude = formatCoordinate(selectedAsset?.lng, 5)

  const stats = [
    { label: 'Asset Value', value: assetValue },
    { label: 'Latitude', value: latitude },
    { label: 'Longitude', value: longitude },
  ]

  return (
    <div className="rounded-[8px] border border-eai-bg-lt2 bg-white px-3 py-3 flex flex-col gap-3">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          {assetImage ? (
            <img
              src={assetImage}
              alt={assetName}
              className="h-[58px] w-[86px] rounded-[5px] object-cover"
            />
          ) : (
            <div className="h-[58px] w-[86px] rounded-[5px] border border-eai-bg-lt2 bg-white flex items-center justify-center">
              <GroupIcon className="h-6 w-6 text-slate-500" />
            </div>
          )}
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-3">
              <h2 className="text-[18px] font-semibold text-black">{assetName}</h2>
              <span className="rounded-[15px] bg-[#DEF7EC] px-3 py-1 text-xs font-medium text-[#0E9F6E]">
                {ownerOrOrgLabel || 'Unknown Owner'}
              </span>
            </div>
            <p className="text-xs text-[#62748E]">{assetDescription}</p>
          </div>
        </div>
        <button
          type="button"
          className="inline-flex items-center gap-2 rounded-[6px] bg-[#879643] px-3 py-2 text-xs font-medium text-white shadow-[0px_1px_3px_0px_rgba(16,24,40,0.1),0px_1px_2px_0px_rgba(16,24,40,0.06)]"
        >
          <PinIcon className="h-3 w-3" />
          Pin to Dashboard
        </button>
      </div>

      <div className="h-px w-full bg-eai-bg-lt2" />
      <div className="flex items-center gap-2">
        {stats.map((stat) => (
          <div
            key={stat.label}
            className="flex h-[60px] w-[123px] flex-col items-center justify-center rounded-[8px] border border-eai-bg-lt2 bg-white shadow-[0px_4px_4px_1px_rgba(0,0,0,0.02)]"
          >
            <div className="text-[13px] font-semibold text-[#464646]">{stat.value}</div>
            <div className="text-xs text-[#62748E]">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AssetPageHeader
